import * as Reflux from "reflux";
export const DatePickerActions = {
	setCheckoutDeliveryDate: Reflux.createAction(["setCheckoutDeliveryDate"]),
	setCartDeliveryDate: Reflux.createAction(["setCartDeliveryDate"]),
	setPickupDate: Reflux.createAction(["setPickupDate"]),
};
